import React from 'react'
import PropTypes from 'prop-types'
import Dialog from '..'
import ButtonRounded from '../../ButtonRounded'

const NotFoundErrorDialog = ({ title, subtitle }) => (
  <div>
    <Dialog
      title={title}
      subtitle={subtitle}
      data-testid="not-found-error-dialog"
    />
    <ButtonRounded
      theme="dark"
      text="Browse programmes"
      href="/categories"
    />
  </div>
)

NotFoundErrorDialog.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
}

NotFoundErrorDialog.defaultProps = {
  title: "Sorry, we couldn't find that episode.",
  subtitle: 'Looking for something else to watch?',
}

export default NotFoundErrorDialog
